// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__6owga","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2WHZg","obliqueLine":"membershipbadge_obliqueLine__mN7Lh"};